<bn-loading-overlay></bn-loading-overlay>

<div class="row">
    <div class="col">
        <h4>Empresas bloqueadas</h4>
    </div>
    <div class="col-auto">
        <div class="bn-form-group botoes">
            <div class="float-end btn1">
              <span class="d-inline-block" tabindex="0" ngbTooltip="Tela para consulta de um lote de CNPJ´s">
                <button class="btn btn-primary botaoMenor" type="button" [routerLink]="['/empresas-bloqueadas/cadastro/lote']"
                  [disabled]="naoPodeConsultarEmpresasBloqueadas">
                  <i class="fa fa-upload"> </i> Envio em Lote</button>
              </span>
            </div>
            <div class="float-end btn2">
              <span class="d-inline-block" tabindex="0" ngbTooltip="Tela para consulta individual de CNPJ">
                <button class="btn btn-primary botaoMenor " type="button" [routerLink]="['/empresas-bloqueadas/cadastro/individual']"
                  [disabled]="naoPodeConsultarEmpresasBloqueadas">
                  <i class="fa fa-file-signature"></i> Envio Individual</button>
              </span>
            </div>
            <div *ngIf="naoPodeConsultarEmpresasBloqueadas" class="float-end btn3">
              <span class="d-inline-block" tabindex="0" ngbTooltip="Exporta um arquivo CSV com as empresas bloqueadas">
                <button class="btn btn-primary botaoMenor" type="button" (click)="baixarEmpresasBloqueadas()">
                  <i class="fa fa-file"> </i> Download</button>
              </span>
            </div>
        </div>
    </div>
</div>
<div class="row">
    <div class="container">
        <div class="justificado">
            <span class="color-red">Atenção!</span>
            <br><br>

            A consulta informará apenas os números-bases (8 dígitos) dos CNPJs que, no momento, encontram-se em pelo menos uma das seguintes situações:<br><br>
            • CNPJs impedidos de contratar novas operações nesta modalidade, pois têm alguma situação impeditiva, tais como: honra paga com valor honrado a recuperar em alguma operação garantida, ou indícios de descumprimento identificado pelo administrador; ou<br>
            • CNPJs com perspectiva de ficarem impedidos de contratar novas operações por terem uma ou mais solicitações de honra em processamento com perspectiva de pagamento de honra em breve, que pode ou não vir a ocorrer, a depender de validações previstas, ou mesmo possibilidade de cancelamento da solicitação de honra devido ao pagamento pelo tomador do crédito da dívida vencida, entre outros casos.<br>

            <br>

            Todos os CNPJs que contiverem o mesmo número-base (isto é, os mesmos 8 dígitos iniciais) estarão na mesma condição.<br>Exemplo: O CNPJ 12345678/0001-01 estará impedido de contratar caso 12345678 conste na lista como impedido.
        </div>
    </div>
</div>
